import { apiRequest } from './axiosConfig';
import { isValidReportSlug, ReportNotFoundError } from './reportService';

export interface AnalyzeResponse {
  analysis: {
    title: string;
    description: string;
    domain: string;
    logo_url: string | null;
    og_image_url: string | null;
    colors: string[];
    category: string | null;
  };
}

export interface RegisterAndAnalyzeRequest {
  email: string;
  service_url: string;
  name?: string;
  company_name?: string;
}

export interface RegisterAndAnalyzeResponse {
  lead_id: number;
  report_slug: string;
}

export interface BannerItem {
  style_key: string;
  status: string;
  image_url?: string;
}

export interface ReportStatusResponse {
  report_status: 'pending' | 'processing' | 'completed' | 'failed';
  service_url: string;
  report_data?: {
    analysis: any;
    planning: any;
    banner_session_id?: string;
    generated_at: string;
  } | null;
  planning_data?: any;
  banner_status?: string;
  banners?: BannerItem[];
}

const lpService = {
  /**
   * Step 1: URL analysis (instant result)
   */
  analyze: async (serviceUrl: string): Promise<AnalyzeResponse> => {
    return apiRequest.post<AnalyzeResponse>('lp/analyze', { service_url: serviceUrl });
  },

  /**
   * Step 2: Lead registration + async analysis start
   */
  registerAndAnalyze: async (data: RegisterAndAnalyzeRequest): Promise<RegisterAndAnalyzeResponse> => {
    return apiRequest.post<RegisterAndAnalyzeResponse>('lp/register-and-analyze', data);
  },

  /**
   * Step 3: Report status polling
   */
  getReportStatus: async (slug: string): Promise<ReportStatusResponse> => {
    if (!isValidReportSlug(slug)) {
      throw new ReportNotFoundError();
    }
    return apiRequest.get<ReportStatusResponse>(`lp/report-status/${encodeURIComponent(slug)}`);
  },
};

export default lpService;
